var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout max-w-lg mx-auto"},[_c('HeaderComp'),_c('router-view',{staticClass:"layout-main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }